import React from "react";
import "./EmbeddingNativeRootApp.css";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { Box, Alert } from "@mui/material";

import { onLogout, onLogin } from "../../redux/session/actions";
import BasicToolbar from "../../generic/components/toolbar/BasicToolbar";
import { embeddingService } from "../../generic/services/EmbeddingService";
import CustomTabs from "../../generic/components/main-content/CustomTabs";
import FilterContainer from "../../generic/components/filters/FilterContainer";
import { dossierService } from "../../generic/services/DossierService";
import { promptService } from "../../generic/services/PromptService";
import { mstrPath } from "../../utils/mstrBase";

const PROMPTED = 2;

function EmbeddingNativeRootApp(props) {
  const { token, config, userDetails, messageBundles } = props;
  const history = useHistory();
  const [dossierData, setDossierData] = useState(null);
  const [environment, setEnvironment] = useState(null);
  const [currentDossierEmbedded, setCurrentDossierEmbedded] = useState(null);
  const [filters, setFilters] = useState(config.applications.embedding_native.filters);
  const [error, setError] = useState(null);

  useEffect(() => {
    renderDossier();
  }, [token]);

  const renderDossier = async (environment, dossier) => {
    try {
      let prompts = "";

      environment = await embeddingService.getEnvironment(
        config,
        token,
        environment,
        setEnvironment,
      );
      //If the current dossier is not set, we take the first one from configuration list.
      dossier =
        dossier == undefined ? config.applications.embedding_native.embeddedDossier[0] : dossier;
      //Generate instance from the dossier.
      let instance = await dossierService.createDossierInstance(
        config,
        token,
        dossier.projectId,
        dossier.id,
      );

      if (instance.status === PROMPTED) {
        prompts = await promptService.populate(
          config,
          token,
          dossier.projectId,
          dossier.id,
          instance.mid,
        );
        await promptService.answer(
          config,
          token,
          dossier.projectId,
          dossier.id,
          instance.mid,
          prompts,
          config.applications.embedding_native.filters,
        );
      }
      setDossierData({
        projectId: dossier.projectId,
        dossierId: dossier.id,
        dossierInstanceId: instance,
        prompts: prompts,
        visualizations: dossier.visualizations,
      });

      embeddingService.renderDossierNative(
        document.getElementById("embedding_native-root"),
        dossier.projectId,
        dossier.id,
        instance.mid,
        environment,
        true,
        dossier.visualizations,
        currentDossierEmbedded,
        setCurrentDossierEmbedded,
      );
    } catch (e) {
      if (e.id === "INVALID_CREDENTIALS") {
        history.push(mstrPath("login"));
      } else {
        setError(e.message);
      }
    }
  };

  const handleFilterChange = async (filterValues) => {
    setFilters(filterValues);
    const { mid } = await promptService.rePrompt(
      config,
      token,
      dossierData.projectId,
      dossierData.dossierId,
      dossierData.dossierInstanceId.mid,
    );

    await promptService.answer(
      config,
      token,
      dossierData.projectId,
      dossierData.dossierId,
      mid,
      dossierData.prompts,
      Object.values(filterValues),
    );

    setDossierData({
      projectId: dossierData.projectId,
      dossierId: dossierData.dossierId,
      dossierInstanceId: { ...dossierData.dossierInstanceId, mid: mid },
      prompts: dossierData.prompts,
    });

    embeddingService.renderDossierNative(
      document.getElementById("embedding_native-root"),
      dossierData.projectId,
      dossierData.dossierId,
      dossierData.dossierInstanceId.mid,
      environment,
      true,
      dossierData.visualizations,
      currentDossierEmbedded,
      setCurrentDossierEmbedded,
    );
  };
  const onChangeTab = (dossierID) => {
    const dossier = config.applications.embedding_native.embeddedDossier.find(
      (x) => x.id === dossierID,
    );

    renderDossier(environment, dossier, dossierID);
  };

  return (
    <Box id="embedding-root">
      <BasicToolbar id="embedding-toolbar" pageName="Embedding Sample">
        {config.applications.embedding_native.filters.map((filter, index) => (
          <FilterContainer
            key={filter.label || index}
            config={config}
            elements={filter.elements}
            filter={filter}
            filters={filters}
            handleFilterChange={handleFilterChange}
            index={index}
            initialValue={filter.value}
            label={filter.label}
            setFilters={setFilters}
          />
        ))}
      </BasicToolbar>

      <CustomTabs disabled={currentDossierEmbedded == null} onTabChange={onChangeTab}>
        {config.applications.embedding_native.embeddedDossier.map((doss) => {
          return <Box key={doss.key} did={doss.id} tabName={doss.tabName} />;
        })}
      </CustomTabs>
      <Box id="embedding_native-root" />
      {error && (
        <Alert severity="error" sx={{ width: "40%", marginTop: "10px" }} variant="filled">
          {error.message}
        </Alert>
      )}
    </Box>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.userDetails?.token,
    config: state.configuration,
    messageBundles: state.configuration?.messageBundles,
    userDetails: state.userDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      onLogin: onLogin,
      onLogout: onLogout,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(EmbeddingNativeRootApp);
